import { ActivityOwner } from '../activity/activity-owner';
import { Linkable } from '../entityLink/linkable';
import { Label } from '../label/label';
import { CommandTemplate } from '../commandTemplate/commandTemplate';
import { User } from '../user/user';
import { HasCommands } from '../../services/command/command.service';
import { IssueStatus } from './issue-status';
import { IssueType } from './issue-type';
import { Location } from '../location/location';

export interface HasLabels {
  getEntityId(): string;
  getEntityType(): string;
}

export interface HasLocation {
  getEntityId(): string;
  getEntityType(): string;
}

export class Issue implements Linkable, HasCommands, ActivityOwner, HasLabels, HasLocation {
  static ENTITY_TYPE: string = 'Issue';

  id: string;
  externalId: string;
  number: number;
  prefixedNumber: string | undefined;
  title: string;
  description: any;
  issueStatus: IssueStatus | undefined;
  issueType: IssueType | undefined;
  icon: string;
  color: string;
  assignee: User | undefined;
  commands: CommandTemplate[];
  createdBy: User;
  createdDateTime: string;
  lastModifiedDateTime: string;
  labels: Label[];
  dueDateTime: string | undefined;
  noteCount: number | undefined;
  fileCount: number | undefined;
  location: Location | undefined;
  aggregationRootId: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.issueStatus = payload.issueStatus;
      this.issueType = payload.issueType;
      this.title = payload.title;
      this.number = payload.number;
      this.prefixedNumber = payload.prefixedNumber;
      this.icon = payload.icon;
      this.color = payload.color;
      this.description = payload.description;
      if (payload.issueStatus) {
        this.issueStatus = new IssueStatus(payload.issueStatus);
      }
      if (payload.issueType) {
        this.issueType = new IssueType(payload.issueType);
      }
      if (payload.commands) {
        this.commands = payload.commands.map((command: any) => new CommandTemplate(command));
      }
      if (payload.createdBy) {
        this.createdBy = new User(payload.createdBy);
      }
      if (payload.assignee) {
        this.assignee = new User(payload.assignee);
      }
      this.createdDateTime = payload.createdDateTime;
      this.lastModifiedDateTime = payload.lastModifiedDateTime;
      if (payload.labels) {
        this.labels = Label.createLabels(payload.labels);
      }
      this.dueDateTime = payload.dueDateTime;
      this.noteCount = payload.noteCount;
      this.fileCount = payload.fileCount;
      if (payload.location) {
        this.location = new Location(payload.location);
      }
      this.aggregationRootId = payload?.aggregationRootId;
    }
  }

  getEntityId(): string {
    return this.id;
  }

  getCollectionRoute(): string {
    return '/issues';
  }

  get text(): string {
    return this.title;
  }

  get entityType(): string {
    return Issue.ENTITY_TYPE;
  }

  getEntityType(): string {
    return Issue.ENTITY_TYPE;
  }

  public getPrefixedNumber(): string {
    if (this.issueType && this.issueType.prefix) {
      return this.issueType.prefix + '-' + this.number;
    }
    return '';
  }

  static createIssues(result: Array<any>): Issue[] {
    const issues = new Array<Issue>();
    if (result) {
      result.map((timeEntry) => {
        issues.push(new Issue(timeEntry));
      });
    }
    return issues;
  }
}
